import {Link, To, useLocation, useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import {reissue} from "./UtilComponent";
import axios from "axios";
import React, {useContext, useState} from "react";
import Url from './Url';
import {RootState} from "../../redux/store";


function Header(props: any) {
    const url = useContext(Url)
    const navigate = useNavigate();
    const location = useLocation();
    const user = useSelector((state: RootState) => state.user.value);
    const [InfoOpen, setInfoOpen] = useState(false);

    let userId = user.id;

    const logOut = () => {
        reissue(userId, url, navigate).then(() => {
            axios.post(url + 'logout', {
                userId: user.id,
            }).then(() => {
                    localStorage.clear();
                    navigate('/login')
                }
            ).catch((e) => {
                console.log(e)
            })
        })
    }

    const toggleSubMenu = () => {
        setInfoOpen(!InfoOpen);
    };

    const handlePwChange = (to: To) => (e: React.MouseEvent<HTMLSpanElement>) => {
        if (location.pathname === to) {
            e.preventDefault();
            window.location.reload();
        } else {
            navigate(to);
        }
    };

    return (
        <div className="d-sm-flex align-items-center justify-content-between mb-4 mt-4">
            <h1 className="h3 mb-0 text-gray-800">{props.pageName}</h1>
            <div style={{display: 'flex'}}>
                <div onClick={toggleSubMenu} style={{marginRight: '10px', cursor: "pointer"}} className='loginName'>
                    {userId}님
                    {!InfoOpen ?
                        <img width="14" height="14" style={{transform: 'rotate(-180deg)', marginLeft: '1rem'}}
                             src="https://img.icons8.com/ios/20/000000/collapse-arrow--v1.png"
                             alt="collapse-arrow--v1"/> :
                        <img width="14" height="14" style={{marginLeft: '1rem'}}
                             src="https://img.icons8.com/ios/50/000000/collapse-arrow--v1.png"
                             alt="collapse-arrow--v1"/>
                    }
                </div>
                {InfoOpen && (
                    <div style={{display: 'flex'}} className="side-menu">
                        <span onClick={handlePwChange('/PasswordChange')} className="side-list">
                            비밀번호변경
                        </span>
                    </div>
                )}
                <Link to="#" onClick={logOut} className="logout">
                    <span id="text">로그아웃</span>
                </Link>
            </div>
        </div>
    );
}

export default Header